import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { HomeComponent } from './home/home.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';

import { AdmCategoryService } from './globalService/adm-category.service';
import { CamposControlErrorComponent } from './campos-control-error/campos-control-error.component';
import { JwtHelperService, JwtModule } from '@auth0/angular-jwt';
import { AuthGuardService } from './globalService/auth-guard.service';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { FooterComponent } from './footer/footer.component';
import { DataTablesModule } from 'angular-datatables';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AuthLayoutComponent } from './layouts/auth/auth-layout/auth-layout.component';
import { ComponentsModule } from './components/components.module';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { ClainsLayoutComponent } from './layouts/clains-layout/clains-layout.component';
import { WepacLayoutComponent } from './layouts/wepac-layout/wepac-layout.component';
import { GeneralModule } from './general-modules/general/general.module';
import { SarlaftLayoutComponent } from './layouts/sarlaft-layout/sarlaft-layout.component';
import { UserComercialComponent } from './pages/user-comercial/user-comercial.component';
import { TableEmpresaComponent } from './pages/user-comercial/table-empresa/table-empresa.component';
import { DxLoadPanelModule } from 'devextreme-angular';
import { AdminLayoutModule } from './layouts/admin-layout/admin-layout.module';
import { CuposycumulosLayoutComponent } from './layouts/cuposycumulos-layout/cuposycumulos-layout.component';
import { RouterModule } from '@angular/router';
import { WeCumplimientoLayoutComponent } from './layouts/wecumplimiento-layout/wecumplimiento-layout.component';



export function getToken(): string {
  return sessionStorage.getItem("jwt");
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    CamposControlErrorComponent,
    NavBarComponent,
    FooterComponent,
    AuthLayoutComponent,
    AdminLayoutComponent,
    ClainsLayoutComponent,
    WepacLayoutComponent,
    SarlaftLayoutComponent,
    CuposycumulosLayoutComponent,
    UserComercialComponent,
    TableEmpresaComponent,
    WeCumplimientoLayoutComponent
    
  ],
  imports: [
    BrowserModule,
    RouterModule,
    AppRoutingModule,
    HttpClientModule,
    ComponentsModule,
    AutoCompleteModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    JwtModule.forRoot({
      config: {
        tokenGetter: getToken
      }
    }),
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 10000,
      closeButton: true,
      autoDismiss: false,
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
    }),
    DataTablesModule,
    GeneralModule,
    DxLoadPanelModule,
    AdminLayoutModule
  ],
  providers: [
    AdmCategoryService,
    AuthGuardService,
    JwtHelperService
  ],
  exports:[
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class AppModule { }
